'use client'
import { FormEvoSetup } from '@repo/third-party-forms-components/FormEvoSetup'
import MUIStack from '@mui/material/Stack'

const ThirdPartyForms = () => {
  return (
    <MUIStack data-testid="ThirdPartyForms" gap={6}>
      <FormEvoSetup />
    </MUIStack>
  )
}

export default ThirdPartyForms
